import { extendTheme, type ThemeConfig } from '@chakra-ui/react';

const config: ThemeConfig = {
  initialColorMode: 'dark',
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  fonts: {
    heading: 'Nasalization, sans-serif',
  },
  colors: {
    brand: {
      primary: '#e1fa00',
      secondary: '#00392b',
    },
  },
  styles: {
    global: (props: { colorMode: 'light' | 'dark' }) => ({
      body: {
        color: props.colorMode === 'dark' ? 'white' : 'black',
        bg: props.colorMode === 'dark' ? 'gray.800' : 'white',
      },
    }),
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'bold',
      },
      variants: {
        solid: (props: { colorMode: 'light' | 'dark' }) => ({
          bg: 'brand.primary',
          color: 'black',
          _hover: {
            bg: 'brand.secondary',
            color: 'white',
          },
        }),
      },
    },
    Heading: {
      baseStyle: (props: { colorMode: 'light' | 'dark' }) => ({
        color: props.colorMode === 'dark' ? 'brand.primary' : 'brand.secondary',
        fontFamily: 'Nasalization, sans-serif',
      }),
    },
  },
});

export default theme; 